import { render, staticRenderFns } from "./BookingCancelReason.vue?vue&type=template&id=c971b2a0&scoped=true"
import script from "./BookingCancelReason.vue?vue&type=script&lang=ts"
export * from "./BookingCancelReason.vue?vue&type=script&lang=ts"
import style0 from "./BookingCancelReason.vue?vue&type=style&index=0&id=c971b2a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c971b2a0",
  null
  
)

export default component.exports